var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



function setCookie(e,t){var n=new Date;n.setTime(n.getTime()+144e5);var o="expires="+n.toUTCString();document.cookie=e+"="+t+";"+o+";path=/"};
async function getCookie(e){for(var t=e+"=",n=decodeURIComponent(document.cookie).split(";"),o=0;o<n.length;o++){for(var i=n[o];" "==i.charAt(0);)i=i.substring(1);if(0==i.indexOf(t))return i.substring(t.length,i.length)}return""};

function loadScript(scriptUrl) {
  const script = document.createElement('script');
  script.src = scriptUrl;
  document.body.appendChild(script);
  
  return new Promise((res, rej) => {
    script.onload = function() {
      res();
    }
    script.onerror = function () {
      rej();
    }
  });
}

window.Components = {},
	window.Components.menu = function (e = {
		open: !1
	}) {
		return {
			init() {
				this.items = Array.from(this.$el.querySelectorAll('[role="menuitem"]')),
					this.$watch("open", (() => {
						this.open && (this.activeIndex = -1)
					}
					))
			},
			activeDescendant: null,
			activeIndex: null,
			items: null,
			open: e.open,
			focusButton() {
				this.$refs.button.focus()
			},
			onButtonClick() {
				this.open = !this.open,
					this.open && this.$nextTick((() => {
						this.$refs["menu-items"].focus()
					}
					))
			},
			onButtonEnter() {
				this.open = !this.open,
					this.open && (this.activeIndex = 0,
						this.activeDescendant = this.items[this.activeIndex].id,
						this.$nextTick((() => {
							this.$refs["menu-items"].focus()
						}
						)))
			},
			onArrowUp() {
				if (!this.open)
					return this.open = !0,
						this.activeIndex = this.items.length - 1,
						void (this.activeDescendant = this.items[this.activeIndex].id);
				0 !== this.activeIndex && (this.activeIndex = -1 === this.activeIndex ? this.items.length - 1 : this.activeIndex - 1,
					this.activeDescendant = this.items[this.activeIndex].id)
			},
			onArrowDown() {
				if (!this.open)
					return this.open = !0,
						this.activeIndex = 0,
						void (this.activeDescendant = this.items[this.activeIndex].id);
				this.activeIndex !== this.items.length - 1 && (this.activeIndex = this.activeIndex + 1,
					this.activeDescendant = this.items[this.activeIndex].id)
			},
			onClickAway(e) {
				if (this.open) {
					const t = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e => `${e}:not([tabindex='-1'])`)).join(",");
					this.open = !1,
						e.target.closest(t) || this.focusButton()
				}
			}
		}
	}
	,
	window.Components.popoverGroup = function () {
		return {
			__type: "popoverGroup",
			init() {
				let e = t => {
					document.body.contains(this.$el) ? t.target instanceof Element && !this.$el.contains(t.target) && window.dispatchEvent(new CustomEvent("close-popover-group", {
						detail: this.$el
					})) : window.removeEventListener("focus", e, !0)
				}
					;
				window.addEventListener("focus", e, !0)
			}
		}
	}
	,
	window.Components.popover = function ({ open: e = !1, focus: t = !1 } = {}) {
		const i = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e => `${e}:not([tabindex='-1'])`)).join(",");
		return {
			__type: "popover",
			open: e,
			init() {
				t && this.$watch("open", (e => {
					e && this.$nextTick((() => {
						!function (e) {
							const t = Array.from(e.querySelectorAll(i));
							!function e(i) {
								void 0 !== i && (i.focus({
									preventScroll: !0
								}),
									document.activeElement !== i && e(t[t.indexOf(i) + 1]))
							}(t[0])
						}(this.$refs.panel)
					}
					))
				}
				));
				let e = i => {
					if (!document.body.contains(this.$el))
						return void window.removeEventListener("focus", e, !0);
					let n = t ? this.$refs.panel : this.$el;
					if (this.open && i.target instanceof Element && !n.contains(i.target)) {
						let e = this.$el;
						for (; e.parentNode;)
							if (e = e.parentNode,
								e.__x instanceof this.constructor) {
								if ("popoverGroup" === e.__x.$data.__type)
									return;
								if ("popover" === e.__x.$data.__type)
									break
							}
						this.open = !1
					}
				}
					;
				window.addEventListener("focus", e, !0)
			},
			onEscape() {
				this.open = !1,
					this.restoreEl && this.restoreEl.focus()
			},
			onClosePopoverGroup(e) {
				e.detail.contains(this.$el) && (this.open = !1)
			},
			toggle(e) {
				this.open = !this.open,
					this.open ? this.restoreEl = e.currentTarget : this.restoreEl && this.restoreEl.focus(),
                  this.$nextTick(() => {
						document.getElementById("menu2").scrollIntoView({ behavior: "smooth" });
					})
			}
		}
	}
	,
	window.Components.radioGroup = function ({ initialCheckedIndex: e = 0 } = {}) {
		return {
			value: void 0,
			active: void 0,
			init() {
				let t = Array.from(this.$el.querySelectorAll("input"));
				this.value = t[e]?.value;
				for (let e of t)
					e.addEventListener("change", (() => {
						this.active = e.value
					}
					)),
						e.addEventListener("focus", (() => {
							this.active = e.value
						}
						));
				window.addEventListener("focus", (() => {
						t.includes(document.activeElement)
				}
				), !0)
			}
		}
	}
	,
	window.Components.tabs = function () {
		return {
			selectedIndex: 0,
			onTabClick(e) {
				if (!this.$el.contains(e.detail))
					return;
				let t = Array.from(this.$el.querySelectorAll('[x-data^="Components.tab("]'))
					, i = Array.from(this.$el.querySelectorAll('[x-data^="Components.tabPanel("]'))
					, n = t.indexOf(e.detail);
				this.selectedIndex = n,
					window.dispatchEvent(new CustomEvent("tab-select", {
						detail: {
							tab: e.detail,
							panel: i[n]
						}
					}))
			},
			onTabKeydown(e) {
				if (!this.$el.contains(e.detail.tab))
					return;
				let t = Array.from(this.$el.querySelectorAll('[x-data^="Components.tab("]'))
					, i = t.indexOf(e.detail.tab);
				"ArrowLeft" === e.detail.key ? this.onTabClick({
					detail: t[(i - 1 + t.length) % t.length]
				}) : "ArrowRight" === e.detail.key ? this.onTabClick({
					detail: t[(i + 1) % t.length]
				}) : "Home" === e.detail.key || "PageUp" === e.detail.key ? this.onTabClick({
					detail: t[0]
				}) : "End" !== e.detail.key && "PageDown" !== e.detail.key || this.onTabClick({
					detail: t[t.length - 1]
				})
			}
		}
	},
	window.Components.tab = function (e = 0) {
		return {
			selected: !1,
			init() {
				let t = Array.from(this.$el.closest('[x-data^="Components.tabs("]').querySelectorAll('[x-data^="Components.tab("]'));
				this.selected = t.indexOf(this.$el) === e,
					this.$watch("selected", (e => {
						e && this.$el.focus()
					}
				))
			},
			onClick() {
				window.dispatchEvent(new CustomEvent("tab-click", {
					detail: this.$el
				}))
			},
			onKeydown(e) {
				["ArrowLeft", "ArrowRight", "Home", "PageUp", "End", "PageDown"].includes(e.key) && e.preventDefault(),
					window.dispatchEvent(new CustomEvent("tab-keydown", {
						detail: {
							tab: this.$el,
							key: e.key
						}
					}))
			},
			onTabSelect(e) {
				this.selected = e.detail.tab === this.$el
			}
		}
	}
	,
	window.Components.tabPanel = function (e = 0) {
		return {
			selected: !1,
			init() {
				let t = Array.from(this.$el.closest('[x-data^="Components.tabs("]').querySelectorAll('[x-data^="Components.tabPanel("]'));
				this.selected = t.indexOf(this.$el) === e
			},
			onTabSelect(e) {
				this.selected = e.detail.panel === this.$el
			}
		}
	}

	var Bcp = {
		updateQuantity(line, qty){
			fetch('/cart/change.js', {
				method: 'POST', 
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ quantity: qty, line: line })
			}).then(response => response.json())
			.then(data => { 
				// fire javascript event on window
				window.dispatchEvent(new Event('cart-update'));
				
			})
			.catch((error) => { 
				console.error('Error:', error);
			});
	  }
	};
	window.Bcp = Bcp;


	async function fetchState(){
		let state; 
		state = await fetch('https://ipapi.co/json/?key=KOaQUU8iJ2Su1FynqiXvdeZkTvV4wsEoDO1AwBc1azhLI0G8UN')
			.then(function(response) {
				return response.json();
			})
			.then(res => {
				setCookie("two_day_state", res.region_code);
				return res.region_code;
			})
			.catch(function(error) {
				console.log(error)
			});
		return state;
	}

	async function fetch_eligable(a, b){
		let eligible, skytag;
		for(let i = 0 ; i < b.length; i++){
			if(b[i].includes("bcp2day_eligible")){
				eligible = b[i].split(":")[1];
			}
			if(b[i].includes(`${a}:`)){
				skytag = b[i];
			}
		}
		return {eligible, skytag};
	}
	async function check_sunday(e){
		var count = 0;
		for(let i = 1; i <= e; i++){
			var r = dayjs().add(i, "day").format("ddd");
			if(i === e && "Sat" === r){
				count += 2 ;
			}else {
				if("Sat" === r || "Sun" === r){
					count++;
				}
			}
		}
		var x = count + e;
		return x
	}

	async function calculate_shipping_date(a){
		var usaTime = new Date().toLocaleString("en-US", {timeZone: "America/Los_Angeles"});
		usaTime = new Date(usaTime);
		var hour = usaTime.getHours(), ampm = hour >= 12 ? 'pm' : 'am', flag = (8 > hour && ampm == 'am') ? 0 : 1 ;
		let cal_days = a + flag;
		let check_stasunday = await check_sunday(cal_days);
		var final_date = dayjs().add(check_stasunday, 'day').format("dddd, MMM D");
        var final_date_number = dayjs().add(check_stasunday, 'day').format("D");
		return {message: `FREE SHIPPING`, date: `Get it by ${final_date}`, number: final_date_number};
	}

	async function start_shipping(state,sky, tag){
		let get_bigquery = await fetchbigquery_table(state);
		let SKYQty = tag.split(":")[1].split("-");
		let obj = [{state: "CA", value: parseInt(get_bigquery[0].california_shipping_days), qty: SKYQty[0]}, {state: "GA", value : parseInt(get_bigquery[0].georgia_pooler_shipping_days), qty: SKYQty[1]}, {state: "IN", value: parseInt(get_bigquery[0].indiana_4_3374_plainfield_shi), qty: SKYQty[2]},{state: "TA", value: parseInt(get_bigquery[0].texas_shipping_days), qty: SKYQty[3]}];
		let sortobj = obj.sort((a, b) => a.value - b.value);
		let get_priority = await set_priority(sortobj);
		if(get_priority < 4){
			
			let calculate_date = await calculate_shipping_date(get_priority);
			return calculate_date;
		}else {
			return {message: "FREE SHIPPING", date: "Arrives in 2-7 business days"};
		}
	}



	async function set_priority(b){
		let value; 
		for(let i = 0; i < b.length ; i ++){
			if(b[i].qty > 0){
				value = b[i].value;
				break;
			}
		}
		return value;
	}
	async function fetchbigquery_table(s){
		const queryData = [{"destination_state":"CO","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"2.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"AZ","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"4.0","california_shipping_days":"2.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"ID","texas_shipping_days":"4.0","georgia_pooler_shipping_days":"4.0","california_shipping_days":"2.0","indiana_4_3374_plainfield_shi":"4.0"},{"destination_state":"UT","texas_shipping_days":"2.0","georgia_pooler_shipping_days":"4.0","california_shipping_days":"2.0","indiana_4_3374_plainfield_shi":"4.0"},{"destination_state":"NV","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"5.0","california_shipping_days":"2.0","indiana_4_3374_plainfield_shi":"5.0"},{"destination_state":"WA","texas_shipping_days":"4.0","georgia_pooler_shipping_days":"5.0","california_shipping_days":"2.0","indiana_4_3374_plainfield_shi":"4.0"},{"destination_state":"OR","texas_shipping_days":"4.0","georgia_pooler_shipping_days":"5.0","california_shipping_days":"2.0","indiana_4_3374_plainfield_shi":"4.0"},{"destination_state":"TX","texas_shipping_days":"1.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"3.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"NE","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"3.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"NM","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"3.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"OK","texas_shipping_days":"1.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"3.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"KS","texas_shipping_days":"2.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"3.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"MO","texas_shipping_days":"2.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"3.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"WY","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"4.0","california_shipping_days":"3.0","indiana_4_3374_plainfield_shi":"4.0"},{"destination_state":"MT","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"4.0","california_shipping_days":"3.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"PA","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"DE","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"VA","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"AL","texas_shipping_days":"2.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"LA","texas_shipping_days":"2.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"TN","texas_shipping_days":"2.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"IN","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"1.0"},{"destination_state":"KY","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"1.0"},{"destination_state":"OH","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"1.0"},{"destination_state":"IL","texas_shipping_days":"2.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"1.0"},{"destination_state":"MS","texas_shipping_days":"2.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"MD","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"AR","texas_shipping_days":"2.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"NJ","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"FL","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"WV","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"1.0"},{"destination_state":"SD","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"WI","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"MN","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"IA","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"MI","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"1.0"},{"destination_state":"ND","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"4.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"GA","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"1.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"NC","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"1.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"SC","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"1.0","california_shipping_days":"4.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"VT","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"5.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"RI","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"5.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"MA","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"5.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"CT","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"5.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"NH","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"2.0","california_shipping_days":"5.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"NY","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"5.0","indiana_4_3374_plainfield_shi":"2.0"},{"destination_state":"ME","texas_shipping_days":"4.0","georgia_pooler_shipping_days":"3.0","california_shipping_days":"5.0","indiana_4_3374_plainfield_shi":"3.0"},{"destination_state":"CA","texas_shipping_days":"3.0","georgia_pooler_shipping_days":"4.0","california_shipping_days":"1.0","indiana_4_3374_plainfield_shi":"4.0"}];
		const result = queryData.filter(function (el){
			return el.destination_state === s;
		});
		return result
	}


	async function two_Day(sku, a){
		let get_eligable = await fetch_eligable(sku, a);
		if(get_eligable.eligible == "true"){
			var state_name = await getCookie("two_day_state");
			if(state_name === undefined || state_name === null || state_name.length === 0 || state_name === ""){
				let datas = await fetchState();
				let data = await start_shipping(datas, sku, get_eligable.skytag);
				document.getElementById("change_date").innerHTML = data.date;
				return data.message;
			}else {
				let data = await start_shipping(state_name, sku, get_eligable.skytag);
				document.getElementById("change_date").innerHTML = data.date;
				return data.message;
			}

		}else {
			document.getElementById("change_date").innerHTML = `Arrives in 2-7 business days`;
			return `FREE SHIPPING`;
		}
	}


	window.onscroll = function() {myFunction()};
	var header = document.getElementById("shopify-section-header");
	var sticky = header.offsetTop;
	function myFunction() {
	  if (window.pageYOffset > sticky) {
	    header.classList.add("sticky");
	  } else {
	    header.classList.remove("sticky");
	  }
	}
const localStorageKey = 'algolia_analytics_clicked_objects';

function saveForConversionTracking(data) {
	let userTokn;
  	aa('getUserToken', null, (err, userToken) => {
    	if (err) {
      			console.error(err);
     	 return;
    }
    userTokn = userToken;
  });
	try {
		const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
		const previousClickItems = JSON.parse(previousClickItemsString);
  
		var conversionData = data;
  
		// Changing the event to 'convert' from 'click'
		conversionData.eventName = 'convert';
		conversionData.userToken = userTokn;
		// Removing the `positions` property
		delete conversionData.positions;
  
		// Add the current products data to local storage
		previousClickItems.push(conversionData)
		//console.log(JSON.stringify(previousClickItems));
		localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
	  } catch (error) {
		// No need to do anything in this scenario
	  }
}

 function trackConversion() {
	try {
	  // Get any previously stored data.
	  const previousClickItemsString = localStorage.getItem(localStorageKey)
	  // If data was found, send a conversion event for those products.
	  if (!!previousClickItemsString) {
		const previousClickItems = JSON.parse(previousClickItemsString)
		previousClickItems.forEach((data) => {
		  aa('convertedObjectIDsAfterSearch', data)
		})
	  }
	} catch (error) {
	  // No need to do anything in this scenario.
	}
  
	// Try to remove the items from local storage.
	try {
	  localStorage.removeItem(localStorageKey)
	} catch (error) {
	  // No need to do anything in this scenario.
	}
  }



